/**
 * InlineNotification - Reusable notification component for SimpleKeywordTabs
 */

import React from 'react';
import { CheckCircle, AlertCircle, Clock } from 'lucide-react';
import { InlineNotificationProps } from '../types/keywordTabsTypes';

const InlineNotification: React.FC<InlineNotificationProps> = ({ type, title, message, onDismiss }) => {
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle className="h-5 w-5 text-green-600" />;
      case 'error':
        return <AlertCircle className="h-5 w-5 text-destructive" />;
      case 'warning':
        return <AlertCircle className="h-5 w-5 text-yellow-600" />;
      case 'info':
      default:
        return <Clock className="h-5 w-5 text-primary" />;
    }
  };

  const getBgColor = () => {
    switch (type) {
      case 'success':
        return 'bg-green-50 border-green-200';
      case 'error':
        return 'bg-red-50 border-destructive/20';
      case 'warning':
        return 'bg-yellow-50 border-yellow-200';
      case 'info':
      default:
        return 'bg-accent/30 border-accent/50';
    }
  };

  return (
    <div className={`flex items-start gap-3 p-4 rounded-lg border ${getBgColor()} mb-4`}>
      <div className="flex-shrink-0 mt-0.5">
        {getIcon()}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-foreground">
          {title}
        </div>
        <div className="text-sm text-muted-foreground mt-1">
          {message}
        </div>
      </div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="flex-shrink-0 text-muted-foreground hover:text-foreground transition-colors"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default InlineNotification;